// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgFavorite24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M19.7447 5.75529C18.7454 4.75597 17.4951 4.25 16.0375 4.25C15.1479 4.25 14.3095 4.46167 13.5336 4.88265L13.2812 5.02873C12.8641 5.28561 12.4641 5.60943 12.0806 5.99895L12.018 6.064L12.0035 6.04801C11.5732 5.58844 11.0949 5.21111 10.5692 4.91845C9.76975 4.47341 8.8968 4.25 7.9625 4.25C6.50491 4.25 5.25462 4.75597 4.25529 5.75529C3.25551 6.75508 2.75 8.01259 2.75 9.48375C2.75 10.2244 2.88271 10.9563 3.14647 11.6757C3.40736 12.3872 3.84907 13.1592 4.46925 13.9988C5.07275 14.8157 5.87398 15.7335 6.874 16.7552C7.86216 17.7649 9.11134 18.9605 10.6224 20.3433L11.4975 21.133C11.783 21.3907 12.217 21.3907 12.5025 21.133L13.3737 20.3468C14.8887 18.9605 16.1378 17.7649 17.126 16.7552C18.126 15.7335 18.9272 14.8157 19.5307 13.9988C20.1509 13.1592 20.5926 12.3872 20.8535 11.6757C21.1173 10.9563 21.25 10.2244 21.25 9.48375C21.25 8.01259 20.7445 6.75508 19.7447 5.75529ZM14.2489 6.2011C14.8047 5.89958 15.3971 5.75 16.0375 5.75C17.1016 5.75 17.9692 6.10111 18.684 6.81596C19.3984 7.53034 19.75 8.40491 19.75 9.48375C19.75 10.0464 19.649 10.6037 19.4452 11.1593C19.2386 11.7228 18.8657 12.3745 18.3243 13.1075C17.7661 13.8631 17.009 14.7303 16.054 15.706L15.7838 15.9801C14.8614 16.9095 13.7215 17.9953 12.3649 19.2367L11.999 19.565L11.6312 19.2332C10.1428 17.8712 8.91284 16.6939 7.946 15.706C6.99102 14.7303 6.23391 13.8631 5.67575 13.1075C5.13427 12.3745 4.76139 11.7228 4.55478 11.1593C4.35104 10.6037 4.25 10.0464 4.25 9.48375C4.25 8.40491 4.60157 7.53034 5.31596 6.81596C6.0308 6.10111 6.89842 5.75 7.9625 5.75C8.6432 5.75 9.26483 5.90909 9.83957 6.22905C10.4252 6.55506 10.9403 7.03056 11.3873 7.66376C11.6777 8.07513 12.2829 8.08917 12.592 7.69171C13.1269 7.00398 13.6805 6.50951 14.2489 6.2011Z"
				/>
			</Svg>
		);
	}
);
SvgFavorite24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgFavorite24;
